/**
 * Get the bot username (NEXT_PUBLIC_BOT_USERNAME at build time).
 */
export const getBotUsername = (): string => {
  return process.env.NEXT_PUBLIC_BOT_USERNAME || 'dev_cs_shot_bot';
};

/**
 * Get the Mini App short name (for direct app links)
 */
export const getMiniAppName = (): string => {
  return 'app';
};

export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production';
};

export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV !== 'production';
};
